import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import { CheckboxUIModel } from "@/Common/Models/UI/Inputs/CheckboxUIModel";

export class UrgencyPriority {
    public static UrgencyListAsCheckboxUIModel(): CheckboxUIModel[] {
        return [UrgencyPriority.UrgentPriority, UrgencyPriority.NotUrgentPriority];
    }

    public static get UrgentPriority(): CheckboxUIModel {
        return new CheckboxUIModel({
            Id: "urgency_urgent",
            Name: "UrgentLabel",
            Target: CheckboxTarget.Myle_Documents_Urgency
        });
    }

    public static get NotUrgentPriority(): CheckboxUIModel {
        return new CheckboxUIModel({
            Id: "urgency_not_urgent",
            Name: "NotUrgentLabel",
            Target: CheckboxTarget.Myle_Documents_Urgency
        });
    }
}
